/**
 * Formats a raw amount string from course payment metadata (e.g. "2999")
 * into display copy (e.g. "₹2,999"). Amounts arrive as whole-unit display
 * strings, not minor units. Returns null when the value is missing or not
 * a number, so callers can fall back instead of rendering "₹NaN".
 */
export const formatCurrencyAmount = (
  value: string | undefined,
  currency: string | undefined
): string | null => {
  if (!value) {
    return null;
  }
  const numeric = Number(value);
  if (Number.isNaN(numeric)) {
    return null;
  }
  try {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: currency ?? 'INR',
      maximumFractionDigits: 0,
    }).format(numeric);
  } catch {
    // Unknown ISO currency codes make Intl throw a RangeError.
    return null;
  }
};
